import client from './client'
import type {
  AuthResponse,
  LoginResponse,
  LoginCredentials,
  MigrationCompletePayload,
  MigrationRequiredResponse,
  MigrationSendOtpPayload,
  MigrationSendOtpResponse,
  User,
} from '@/types'

/** Login returns either a session or "go migrate first" — the two shapes are
 *  told apart by this flag, never by the absence of a token. */
export function isMigrationRequired(
  response: LoginResponse
): response is MigrationRequiredResponse {
  return (response as MigrationRequiredResponse).migration_required === true
}

export const authApi = {
  async login(credentials: LoginCredentials): Promise<LoginResponse> {
    const response = await client.post<{ data: LoginResponse }>('/auth/login', credentials)
    return response.data.data
  },

  // The two migration endpoints are unauthenticated by necessity: a user who
  // has not migrated cannot hold a token. The credential travels with every
  // call instead, so both payloads carry the email (and, in password mode,
  // the password).

  async migrationSendOtp(
    payload: MigrationSendOtpPayload
  ): Promise<MigrationSendOtpResponse> {
    const response = await client.post<{ data: MigrationSendOtpResponse }>(
      '/auth/migration/send-otp',
      payload
    )
    return response.data.data
  },

  /** Returns the normal login payload — the portal walks straight in. */
  async migrationComplete(payload: MigrationCompletePayload): Promise<AuthResponse> {
    const response = await client.post<{ data: AuthResponse }>(
      '/auth/migration/complete',
      payload
    )
    return response.data.data
  },

  async getMe(): Promise<User> {
    const response = await client.get<{ data: User }>('/auth/me')
    return response.data.data
  },

  async logout(): Promise<void> {
    await client.post('/auth/logout')
  },
}
